import type { PushToSaveScenarios } from '~/composables/PushToSave'

export default class PushToSaveContent {
  static async use(scenario: PushToSaveScenarios) {
    const { getComponentContent } = Cms.use()
    const [{ content: defaults }, { content: override }] = await Promise.all([
      getComponentContent('PushToSave', 'default'),
      getComponentContent('PushToSave', scenario)
    ])
    const data = computed(() =>
      _mergeWith({}, defaults.value?.data, override.value?.data, (_: unknown, src: unknown) =>
        Array.isArray(src) ? src : undefined
      )
    )
    return { data }
  }
}
